import { useMemo } from 'react';
import { useRouter } from 'next/router';

import { useWebp } from '@r1-frontend/shared/hooks/useWebp';
import CookieAlert from '@r1-frontend/ui-react/organisms/CookieAlert';

import SeoHead from '~/src/components/LandingBlock/SeoHead';
import { getYmIdValue } from '~/src/helpers/ymId';
import { getGaId } from '@r1-frontend/shared/helpers/getGaId';
import ContextContainer from '~/src/containers/ContextContainer';
import LandingBlock from '~/src/components/LandingBlock';
import { ILandingPage } from '~/src/services/projects/prepareServerProps';

const LandingPage = ({
    alias,
    city,
    body,
    seo,
    styles,
    background,
    token,
}: ILandingPage): JSX.Element => {
    const enableWebp = useWebp();

    const ymUid = useMemo(getYmIdValue, []);
    const gaCid = useMemo(getGaId, []);

    const { query: { recaptcha } } = useRouter();
    const enableCaptcha = +recaptcha === 1;

    return (
        <ContextContainer
            city={city}
            gaCid={gaCid}
            enableCaptcha={enableCaptcha}
            enableWebp={enableWebp}
            ymUid={ymUid}
            token={token}
        >
            <SeoHead seo={seo} canonicalHref={`https://${city?.domain}.dom.ru/landing/${alias}`}/>
            <LandingBlock blocks={body} isAdmin={false} background={background} alias={alias} styles={styles}/>
            <CookieAlert/>
        </ContextContainer>
    );
};

export default LandingPage;
